import {Select} from '@mantine/core';
import {useQuery} from '@tanstack/react-query';
import {fetchRecords} from '../../customers/services/CustomersService';

interface CustomerSelectorProps {
    value: string | null;
    onChange: (customerId: string | null) => void;
}

export const CustomerSelector = ({value, onChange}: CustomerSelectorProps) => {
    const {data, isLoading} = useQuery({
        queryKey: ['customers-selector'],
        queryFn: () => fetchRecords({}, 100),
    });

    const options = (data?.items || []).map(c => ({
        value: c.id,
        label: c.name || c.email || c.id,
    }));

    return (
        <Select
            label="Customer"
            placeholder={isLoading ? 'Loading customers...' : 'Select a customer'}
            data={options}
            value={value}
            onChange={onChange}
            searchable
            disabled={isLoading}
        />
    );
};
